module.exports = __webpack_public_path__ + "img/buenos_aires_toda_la_ciudad.d38116ed.jpg";